import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
import router from '../router/index'
import { http } from '../services/config'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'

import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
  },
  state: {
    currentUser: JSON.parse(localStorage.getItem('currentUser')) || false,
    rules: JSON.parse(localStorage.getItem('rules')) || [{ action: 'read', subject: 'Login' }],
    currentLocality: JSON.parse(localStorage.getItem('currentLocality')) || false
  },

  mutations: {
    login(state, user) {
      if (user) {
        state.currentUser = user

        if (user.localities[0] === undefined) {
          state.currentLocality = { id: null }
        } else {
          state.currentLocality = user.localities[0]
        }

        localStorage.setItem("currentLocality", JSON.stringify(state.currentLocality));

        localStorage.setItem("currentUser", JSON.stringify(state.currentUser));
        http.defaults.headers.common['Authorization'] = `bearer ${user.auth_token[0]}`
        Vue.i18n.set(user.locale)

        state.rules = user.rules
        localStorage.setItem('rules', JSON.stringify(user.rules))

        if (user.super_admin) {
          router.push({ name: "companies" })
        } else {
          router.push({ name: "dashboard" });
        }
      } else {
        state.currentUser = false
        localStorage.removeItem('currentUser')

        state.rules = []
        localStorage.removeItem('rules')
        
        delete http.defaults.headers.common['Authorization']
      }
    },

    logout(state) {
      state.currentUser = false
      localStorage.removeItem('currentUser')
      
      state.rules = []
      localStorage.removeItem('rules')

      state.currentLocality = []
      localStorage.removeItem('currentLocality')
      
      delete http.defaults.headers.common['Authorization']
      router.push({name: 'login'})
    },

    updateLocale(state, locale) {
      Vue.i18n.set(locale)
      state.currentUser.locale = locale
      localStorage.setItem("currentUser", JSON.stringify(state.currentUser));
    },

    updateLocality(state, locality) {
      state.currentLocality = locality
      localStorage.setItem("currentLocality", JSON.stringify(locality));
    }
  }
})

Vue.use(VuexI18n.plugin, store)

export default store

Vue.use(ColorThemePlugin, {
  themes: {
    primary: store.state.currentUser.color_primary,
    secondary: store.state.currentUser.color_secondary,
    success: '#000000', 
    info: store.state.currentUser.color_secondary,
    danger: '#A51433',
    warning: '#FFC200',
    gray: '#7F8386',
    dark: '#34495E',
    third: '#FFFFFF',
    green: '#077307',
    greenLight: '#40E583',
    black: '#000000'
  },
})